import {TFunction} from 'i18next';
import {isArray, join} from 'lodash';

import {STATUS_CODES} from 'constants/http';
import {TRANSLATION_KEYS} from 'locale';
import {ApiError} from 'types';

const T_KEYS = TRANSLATION_KEYS.UI_KIT.NOTIFIER.MESSAGES;

export const buildNotifierErrorPropsCommon = (e: ApiError, t: TFunction) => {
    if (e?.response?.status === STATUS_CODES.FORBIDDEN) {
        return {details: t(T_KEYS.FORBIDDEN)};
    } else {
        const errors = e?.response?.data?.errors;
        const details = isArray(errors) ? join(errors) : null;
        return {details};
    }
};